import React from 'react';
import { HERO_COPY } from '../../../shared/config/menuVoteData';
import { VoteMapleOverText } from '../../menu-promo-background';
import {
  CopyLayer,
  Subtitle,
  SubtitleAccent,
  Title,
  TitleAccent,
  TitlePlain,
} from './MenuVoteHero.styles';

/**
 * 메뉴 투표 히어로 카피 (widget)
 * 배경 장식은 PromoLayout → MenuPromoBackground 에서 1회 렌더.
 */
export function MenuVoteHero() {
  return (
    <>
      <CopyLayer>
        <Subtitle>
          {HERO_COPY.subtitlePlain}
          <SubtitleAccent>{HERO_COPY.subtitleAccent}</SubtitleAccent>
        </Subtitle>
        <Title>
          <TitlePlain>{HERO_COPY.titlePlain}</TitlePlain>
          <TitleAccent>{HERO_COPY.titleAccent}</TitleAccent>
        </Title>
      </CopyLayer>
      <VoteMapleOverText />
    </>
  );
}
